// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"2a0a8217","245":"62243ea2","274":"bea926d5","648":"862b1e38","667":"891b2b12"}[chunkId] + ".chunk.js";
};